export const InitialiseChatConnection = () => {
    const socketUrl = `${process.env.REACT_APP_FRONTEND_URL}chat`;
    let socket =  new WebSocket(socketUrl);

    return socket;
}

